import { About } from './components/About'
import { Cases } from './components/Cases'
import { Consulting } from './components/Consulting'
import { Contact } from './components/Contact'
import { Footer } from './components/Footer'
import { Header } from './components/Header'
import { Hero } from './components/Hero'
import { Products } from './components/Products'
import { useLanguage } from './i18n'

export default function App() {
  const { copy } = useLanguage()

  return (
    <>
      <a className="skip-link" href="#consultoria">{copy.skipLink}</a>
      <Header />
      <main>
        <Hero />
        <Consulting />
        <Products />
        <Cases />
        <About />
        <Contact />
      </main>
      <Footer />
    </>
  )
}
